export default{
  "Video Compressor": "वीडियो कंप्रेसर",
  "HitPaw Online Video Compressor": "HitPaw ऑनलाइन वीडियो कंप्रेसर",
  "Best video compressor tool to reduce video file size online without losing quality.": "गुणवत्ता में कोई कमी किये बिना ऑनलाइन वीडियो की फाइल साइज़ कम करने के लिए सबसे अच्छा वीडियो कंप्रेसर टूल।",
  "Quality": "गुणवत्ता",
  "Small Size": "छोटी साइज़ ({{num}}%)",
  "High Quality": "उच्च गुणवत्ता ({{num}}%)",
  "Frame Rate": "फ्रेम दर",
  "Resolution": "रिज़ॉल्यूशन",
  "Keep Resolution": "रिज़ॉल्यूशन बनाये रखें",
  "Format": "फॉर्मेट",
  "Compress": "कंप्रेस करें",
  "Compressing": "कंप्रेस हो रहा है",
  "Compress New": "नया कंप्रेस करें",
  "xx% reduction in size!": "साइज़ में {{num}}% कमी!",
  "Compressed successfully, your file is now xxMB.": "सफलतापूर्वक कंप्रेस किया गया, आपकी फाइल अब <p> {{originalSize}}MB</p> <p>{{compressSize}}MB</p> एमबी है।",
  "Compression Failed": "कंप्रेशन विफल",
};